import React, { useEffect, useState } from 'react';
import ModalRSuite from './ModalRsuite';

const ErrorMessageModal = ({
    isOpen,
    onClose,
    buttonText = 'OK',
    data = { title: '', message: '' },
}) => {
    const [errorData, setErrorData] = useState({ title: '', message: '' })

    useEffect(() => {
        if (isOpen) setErrorData(data)
    }, [isOpen])

    const handleClose = () => {
        onClose()
        setTimeout(() => {
            setErrorData({ title: '', message: '' })
        }, 500)
    }

    return (
        <ModalRSuite
            size="sm"
            open={isOpen} // Ensure it's always a boolean
            className="styled-error-modal"
            closeButton={false}
            onClose={handleClose}
            body={
                <div className="error-modal-wrapper">
                    <div className="icon-circle">
                        <i className="material-icons text-30 text-white">priority_high</i>
                    </div>
                    <div className="error-content text-center mt-3">
                        <h4 className="error-title">{errorData.title}</h4>
                        <p className="error-message">{errorData.message}</p>
                        <button className="error-btn mb-2" onClick={handleClose}>
                            {buttonText}
                        </button>
                    </div>
                </div>
            }
        />
    );
};

export default ErrorMessageModal;
